/* Kai 2026-10-27: same moving dither fire as the Tested In Heat card, behind the footer. */
(function () {
  var box = document.querySelector('[id$="__footer"] .section');
  if (!box || box.querySelector('canvas.st-fire')) return;
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var cv = document.createElement('canvas');
  cv.className = 'st-fire';
  cv.setAttribute('aria-hidden', 'true');
  box.insertBefore(cv, box.firstChild);
  box.classList.add('st-fire-on');
  var ctx = cv.getContext('2d'), W, H, cw, ch, cols, rows, heat, mask, t = 0;
  /* Kai 2026-10-25: no cutouts in the fire behind the words; the text sits on top with a drop shadow (CSS) */
  function knockout() { mask = new Uint8Array(cols * rows); }
  /* Kai 2026-10-25 reference: a faint dot grid everywhere, flames built from o and 0 in flat colors per heat level, low chunky clumps */
  var LEVELS = [[0.12, '.', '#5A1220'], [0.30, '.', '#8A1C2B'], [0.48, 'o', '#A32638'], [0.64, 'o', '#D0213F'], [0.80, '0', '#E2672E'], [1.01, '0', '#FFB347']];
  function step() {
    t += 45;
    var x, y, base = (rows - 1) * cols;
    for (x = 0; x < cols; x++) {
      var wave = 0.62 + 0.38 * Math.sin(x * 0.21 + t * 0.0017) * Math.sin(x * 0.07 - t * 0.0011);
      heat[base + x] = Math.min(1, Math.max(0, wave + (Math.random() - 0.5) * 0.5));
    }
    var decay = 3.1 / rows;
    for (y = 0; y < rows - 1; y++) for (x = 0; x < cols; x++) {
      var xx = Math.min(cols - 1, Math.max(0, x + ((Math.random() * 3) | 0) - 1));
      heat[y * cols + xx] = Math.max(0, heat[(y + 1) * cols + x] - Math.random() * decay * 1.4);
    }
  }
  function draw() {
    ctx.clearRect(0, 0, W, H);
    for (var y = 0; y < rows; y++) for (var x = 0; x < cols; x++) {
      if (mask[y * cols + x]) continue;
      var v = heat[y * cols + x], L = 0;
      while (v >= LEVELS[L][0]) L++;
      ctx.fillStyle = LEVELS[L][2];
      ctx.fillText(LEVELS[L][1], x * cw + cw / 2, y * ch);
    }
  }
  function size() {
    var r = box.getBoundingClientRect(), dpr = Math.min(2, window.devicePixelRatio || 1), small = r.width < 750;
    W = r.width; H = r.height; cv.width = W * dpr; cv.height = H * dpr;
    cw = small ? 8 : 10; ch = small ? 13 : 15; cols = Math.ceil(W / cw); rows = Math.ceil(H / ch);
    heat = new Float32Array(cols * rows);
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    ctx.font = (small ? 12 : 14) + 'px ui-monospace, Menlo, Consolas, monospace';
    ctx.textBaseline = 'top'; ctx.textAlign = 'center';
    knockout();
    for (var i = 0; i < rows * 2; i++) step();
    draw();
  }
  size();
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { knockout(); draw(); });
  window.addEventListener('load', function () { knockout(); draw(); });
  if (window.ResizeObserver) new ResizeObserver(function () { size(); }).observe(box);
  if (reduce) return;
  var visible = true, last = 0;
  if (window.IntersectionObserver) new IntersectionObserver(function (e) { visible = e[0].isIntersecting; }).observe(box);
  (function loop(now) {
    requestAnimationFrame(loop);
    if (!visible || document.hidden || now - last < 45) return;
    last = now; step(); draw();
  })(0);
})();
